import { render } from "./view_asset.html?vue&type=template&id=28e6cf79&external"
import script from "./view_asset.js?vue&type=script&lang=js&external"
export * from "./view_asset.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__